export default __webpack_public_path__ + "static/water_filter_w.0109790e2d3301e75ec37d3c713e067e.svg";